<template>
  <div>
    <h1>Devices</h1>
    <ul>
      <li v-for="device in devices" :key="device.id" class="flex">
        <div class="ml-4 text-left">
          <div>{{ device.attributes.friendly_name }}</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import axios from 'axios'

export default {
  name: 'DeviceList',
  setup() {
    const devices = ref([]) // Use ref to create a reactive variable
    const apiBaseUrl = process.env.VUE_APP_API_BASE_URI

    onMounted(() => {
      axios.get(`${apiBaseUrl}/devices`)
        .then(response => {
          devices.value = response.data // Update the reactive variable
        })
        .catch(error => {
          console.error(error)
        })
    })

    return {
      devices
    }
  }
}
</script>